import "../../scss/pages/nperf-award.scss";
import { loadIframe } from '../helpers/loadIframe';

document.addEventListener("DOMContentLoaded", function () {
	const videoPlaceholder = document.getElementById('videoContainer');
	let iframeLoaded = false;
	const videoId = '7nsgz9LCP3s?si=_kastcDDcP5Kd6Jo';
	
	function onScroll() {
		const rect = videoPlaceholder.getBoundingClientRect();
		if (rect && (rect.top < window.innerHeight && rect.bottom > 0)) {
			loadIframe(iframeLoaded, videoPlaceholder, videoId);
			window.removeEventListener('scroll', onScroll);
		}
	}
	
	window.addEventListener('scroll', onScroll);
	onScroll();
});
